import { h, Fragment } from 'preact';
import { useState, useEffect } from 'preact/hooks';
import AngleRightIcon from 'utils/icon/icon-angle-right.svg';

const Highlights = ({ data }) => {
  const [activeIndex, setActiveIndex] = useState(null);

  const filteredData = data.filter((item) => item.title !== '' && item.content !== '');

  useEffect(() => {
    const initialActiveIndex = filteredData.findIndex((item) => item.open);
    if (initialActiveIndex !== -1) {
      setActiveIndex(initialActiveIndex);
    }
  }, []);

  const handleOpen = (e, index) => {
    e.preventDefault();

    setActiveIndex((prevIndex) => (prevIndex === index ? null : index));
  };

  return (
    filteredData.length > 0 && (
      <div className="mb-20 px-15 md:mb-0 md:px-0">
        <div className={`mb-6 grid gap-6 lg:gap-10 ${filteredData.length > 1 ? 'grid-cols-2' : ''}`}>
          {filteredData.map((item, index) => (
            <Fragment key={`htitle-${index}`}>
              {item.title && (
                <button
                  className={`body-14-med flex cursor-pointer items-center justify-between rounded border bg-grey-6 px-12 py-15 text-primary hover:underline  md:bg-white md:px-15 md:py-22  ${index === activeIndex ? 'border-primary' : 'border-transparent md:border-grey-5'}`}
                  onClick={(e) => handleOpen(e, index)}
                >
                  <div dangerouslySetInnerHTML={{ __html: item.title }}></div>
                  <span className={`${index === activeIndex ? '-rotate-90' : 'rotate-90'}`}>
                    <AngleRightIcon />
                  </span>
                </button>
              )}
            </Fragment>
          ))}
        </div>
        {filteredData.map((item, index) => (
          <Fragment key={`hcontent-${index}`}>
            {item.content && (
              <div
                className={`rte rte--small body-12-light md:body-14-light rounded border bg-grey-6 p-12 md:bg-white md:p-15 ${index === activeIndex ? 'border border-primary' : 'hidden border-transparent'}`}
                dangerouslySetInnerHTML={{ __html: item.content }}
              />
            )}
          </Fragment>
        ))}
      </div>
    )
  );
};

export default Highlights;
